// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { connectedApplicationsResponseSchema } from '@/account/api/get-connected-applications';
import { api } from '@/api/axios-instance';
import { parseResponse } from '@/api/parse-response';

/** Disconnects one of the signed-in person's applications. */
export async function withdrawConnectedApplication(key: string) {
  const path = `/v1/connected-application/${key}`;
  const response = await api.delete(path);

  return parseResponse(connectedApplicationsResponseSchema, response.data, {
    schemaName: 'WithdrawConnectedApplication',
    endpoint: path,
  });
}
